export default "__VITE_ASSET__8pNpLuPu__"